(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("styledStatusSelect", {
            templateUrl: "app/components/styled-status-select/styled-status-select.html",
            controller: statusSelectController,
            scope: {},
            bindings: {
                labelKey: "@",
                model: "=",
                name: "@",
                required: "<",
                options: "<",
                readonly: "<",
                optionsExpression: "@",
                placeholder: "@",
                form: "<",
                statusColors: "<",
                onChange: "&",
            },
        })
        .directive("selectChange", function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs["ngModel"], function (v) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ value: v });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function statusSelectController($scope, $document) {

        $scope.options = [
            {
                label: "flyers.status.sold",
                value: "sold",
                bgColor: "#C2E9CD",
                textColor: "#149E3D",
            },
            {
                label: "flyers.status.reserved",
                value: "reserved",
                bgColor: "#FFF186",
                textColor: "#BBA816",
            },
            {
                label: "flyers.status.available",
                value: "available",
                bgColor: "#B7D9FE",
                textColor: "#3D92EE",
            },
        ];

        $scope.dropdownOpen = false;
        $scope.selectedStatus = null;

        $scope.$onInit = function () {
            validateModel();
            validateOptions();
        };

        $scope.$onInit();

        $scope.$watch("model", function (newValue) {
            if (newValue) {
                $scope.selectedStatus = $scope.options.find(function (status) {
                    return status.value === newValue;
                });
            }
        });

        $scope.toggleDropdown = function (event) {
            if ($scope.$ctrl.readonly) {
                return;
            }
            $scope.dropdownOpen = !$scope.dropdownOpen;
            event.stopPropagation();
        };

        $scope.selectStatus = function (status) {
            $scope.selectedStatus = status;

            $scope.$ctrl.model = status.value;

            if ($scope.$ctrl.onChange) {
                $scope.$ctrl.onChange({ value: status.value });
            }
        };

        $scope.getStyle = function (status) {
            return {
                background: status.bgColor,
                color: status.textColor,
            };
        };

        $scope.getColor = function (status) {
            return {
                color: status.textColor,
            };
        };

        function validateModel() {
            if ($scope.$ctrl.model) {
                var option = $scope.options.find(function (status) {
                    return status.value === $scope.$ctrl.model;
                });
                if (option) {
                    $scope.selectedStatus = option;
                } else {
                    $scope.selectedStatus = $scope.options[0];
                }
            } else {
                $scope.selectedStatus = $scope.options[0];
            }
        }

        function validateOptions() {
            if ($scope.$ctrl.options) {
                $scope.options = $scope.$ctrl.options;
            }
        }

    }
})();
